import { createFileRoute } from "@tanstack/react-router";

import {
  getTailorResumeGuideMetadata,
  TailorResumeToJobDescriptionGuide,
} from "@/components/guides/tailor-resume-to-job-description";

export const Route = createFileRoute("/_home/guides/tailor-resume-to-job-description")({
  component: TailorResumeToJobDescriptionGuide,
  head: () => {
    const metadata = getTailorResumeGuideMetadata();

    return {
      meta: [
        { title: metadata.title },
        { name: "description", content: metadata.description },
        { property: "og:title", content: metadata.title },
        { property: "og:description", content: metadata.description },
        { property: "og:url", content: metadata.ogUrl },
        { property: "twitter:title", content: metadata.title },
        { property: "twitter:description", content: metadata.description },
      ],
    };
  },
});
